/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
  updateBtns: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Modify Product Buttons',
      enabled: true,
      apply: () => ({
        afterRender(element){
          try {
            const parentElement = element?.getParentElm();
            const data =
                parentElement?.getParams()?.props?.product ||
                parentElement?.getParams()?.props?.productData ||
                parentElement?.getParams()?.props?.data ||
                parentElement?.getParentElm()?.getParams()?.props?.productData ||
                parentElement?.getParentElm()?.getParentElm()?.getParams()?.props?.product;

            if (data) {
              let data = element.getParams().props.product;
              let productItem = document.querySelector('[data-product-id="'+ data.id +'"]');
              if (productItem.querySelector('.boost-sd__product-label--sale')) {
                productItem.querySelector('.boost-sd__product-label--sale .boost-sd__product-label-text').classList.add("hc-sale-tag");
              }
            }
          } catch(error) {
            console.log(error);
          }
        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateBtns]);